// composition-api
import { computed, ref } from "vue";
// vuex
import store from "@/store";
// tipos
import {
  Cliente,
  Clientes,
} from "@/typings/store/plugins/easyFirestore/clientes";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useClientes(config?: { ordenarArray?: boolean }) {
  const ordenar = ref(config?.ordenarArray ?? false);

  const setOrdenarArray = (value: boolean) => {
    ordenar.value = value;
  };

  const get = computed(() => {
    return store.getters["clientes/get"] as Clientes;
  });

  const sort = (array: Cliente[]) => {
    array.sort((a, b) => {
      return a.nombre.localeCompare(b.nombre);
    });
  };

  const getArray = computed(() => {
    const clientes = store.getters["clientes/getArray"] as Cliente[];
    if (ordenar.value) {
      sort(clientes);
    }
    return clientes;
  });

  const getArrayHabilitados = computed(() => {
    return getArray.value.filter((cliente) => cliente.estado === "habilitado");
  });

  const getById = (id: string): Cliente | null => {
    if (!id) return null;
    return get.value[id] ?? null;
  };

  return { get, getArray, getArrayHabilitados, setOrdenarArray, getById };
}
